import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { TrustBadges } from '../ui/TrustBadges';
interface HeroProps {
  onOpenQuiz: () => void;
}
export function Hero({
  onOpenQuiz
}: HeroProps) {
  return <section id="hero" className="min-h-screen flex flex-col justify-center pt-[100px] pb-[60px] relative overflow-hidden bg-verde-oscuro" style={{
    backgroundImage: `
          radial-gradient(ellipse at 20% 50%, rgba(45, 122, 82, 0.3) 0%, transparent 60%),
          radial-gradient(ellipse at 80% 20%, rgba(201, 162, 39, 0.1) 0%, transparent 50%)
        `
  }} data-id="element-157">
      <div className="absolute inset-0 pointer-events-none opacity-20" style={{
      backgroundImage: `url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.1'%3E%3Ccircle cx='30' cy='30' r='1'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`
    }} data-id="element-158" />

      <div className="container-custom relative z-10" data-id="element-159">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} data-id="element-160">
          <p className="text-[15px] md:text-[13px] font-semibold tracking-[3px] uppercase text-dorado mb-6" data-id="element-161">
            Para quien lleva años lidiando con el ardor
          </p>

          <h1 className="font-display text-[clamp(32px,5.5vw,60px)] font-black text-blanco leading-[1.15] mb-7" data-id="element-162">
            En 72 horas, el 87% de las personas
            <br data-id="element-163" />
            con tu mismo problema{' '}
            <span className="text-dorado-claro italic" data-id="element-164">
              durmieron toda la noche
            </span>{' '}
            por primera vez en años.
            <br data-id="element-165" />
            <span className="text-[clamp(24px,4vw,42px)] text-white/70 font-bold" data-id="element-166">
              Sin omeprazol. Sin dietas imposibles.
            </span>
          </h1>

          <p className="text-[18px] md:text-[19px] text-white/75 max-w-[620px] mb-10 font-light leading-[1.8]" data-id="element-167">
            Descubrí el <strong data-id="element-168">Protocolo Digestivo de 72 Horas™</strong> — un
            ebook digital con el sistema paso a paso que identifica tus
            detonantes reales y calma tu sistema digestivo de raíz, sin
            medicación de por vida.
          </p>

          <div className="flex gap-10 mb-12 flex-wrap" data-id="element-169">
            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.3
          }} className="flex flex-col" data-id="element-170">
              <span className="font-display text-[36px] font-bold text-dorado-claro leading-none" data-id="element-171">
                72hs
              </span>
              <span className="text-[15px] md:text-[13px] text-white/55 mt-1" data-id="element-172">
                para notar cambios reales
              </span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.4
          }} className="flex flex-col" data-id="element-173">
              <span className="font-display text-[36px] font-bold text-dorado-claro leading-none" data-id="element-174">
                3
              </span>
              <span className="text-[15px] md:text-[13px] text-white/55 mt-1" data-id="element-175">
                pilares del protocolo
              </span>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            x: -20
          }} animate={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: 0.5
          }} className="flex flex-col" data-id="element-176">
              <span className="font-display text-[36px] font-bold text-dorado-claro leading-none" data-id="element-177">
                60%
              </span>
              <span className="text-[15px] md:text-[13px] text-white/55 mt-1" data-id="element-178">
                toma medicamentos que solo enmascaran
              </span>
            </motion.div>
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.6
        }} className="max-w-[360px] w-full border border-dorado/30 rounded-[8px] overflow-hidden mb-12 mx-auto sm:mx-0" data-id="element-179">
            <div style={{
            position: 'relative',
            paddingTop: '177.78%'
          }} data-id="element-180">
              <iframe src="https://player.mediadelivery.net/embed/612153/05e73169-e1cb-4a15-908e-e542d22abeea?autoplay=false&loop=false&muted=false&preload=true&responsive=true" loading="lazy" style={{
              border: 0,
              position: 'absolute',
              top: 0,
              height: '100%',
              width: '100%'
            }} allow="accelerometer;gyroscope;autoplay;encrypted-media;picture-in-picture;" allowFullScreen data-id="element-181" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.8
        }} className="text-center sm:text-left flex flex-col sm:flex-row items-center gap-4" data-id="element-182">
            <button onClick={onOpenQuiz} className="group relative w-full max-w-[480px] bg-gradient-to-br from-dorado/20 via-white/10 to-dorado/10 backdrop-blur-sm border-2 border-dorado/50 rounded-[14px] px-7 py-6 transition-all duration-300 hover:border-dorado hover:shadow-[0_0_50px_rgba(201,162,39,0.25)] hover:scale-[1.02] text-left" data-id="element-183">
              <div className="flex items-center gap-2 mb-3" data-id="element-184">
                <span className="relative flex h-3 w-3" data-id="element-185">
                  <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-dorado-claro opacity-75" data-id="element-186" />
                  <span className="relative inline-flex rounded-full h-3 w-3 bg-dorado" data-id="element-187" />
                </span>
                <span className="text-[13px] md:text-[12px] uppercase tracking-[2px] text-dorado font-bold" data-id="element-188">
                  Diagnóstico gratuito
                </span>
              </div>

              <div className="text-[22px] md:text-[20px] font-bold text-white leading-snug mb-2 group-hover:text-dorado-claro transition-colors" data-id="element-189">
                ¿Qué tan severo es tu reflujo?
              </div>

              <div className="flex items-center justify-between" data-id="element-190">
                <span className="text-[15px] md:text-[14px] text-white/60" data-id="element-191">
                  Solo toma 60 segundos · 100% gratis
                </span>
                <span className="flex items-center justify-center w-10 h-10 rounded-full bg-dorado/20 border border-dorado/40 text-dorado-claro text-xl group-hover:bg-dorado group-hover:text-verde-oscuro transition-all duration-300 group-hover:translate-x-1 shrink-0" data-id="element-192">
                  →
                </span>
              </div>
            </button>
          </motion.div>

          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 1
        }} data-id="element-193">
            <TrustBadges className="sm:justify-start mt-6" theme="dark" data-id="element-194" />
          </motion.div>
        </motion.div>
      </div>
    </section>;
}